import { render, staticRenderFns } from "./StockComfirmHome.vue?vue&type=template&id=1562d796&scoped=true&"
import script from "./StockComfirmHome.vue?vue&type=script&lang=js&"
export * from "./StockComfirmHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562d796",
  null
  
)

export default component.exports